import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';

const useShareDocumentCalls = () => {
  const { generalApiCall } = useGeneralApiCall();

  const getSharedDocument = async ({ code, requestSource }) => {
    const pathname = `/api/share/document/${encodeURIComponent(code)}`;
    return generalApiCall({
      pathname,
      method: 'get',
      notShowErrorMessage: true,
      returnError: true,
      returnCancelled: true,
      requestSource,
    });
  };

  return { getSharedDocument };
};

export default useShareDocumentCalls;
